import { ProductOptions } from "./ProductOptions";

export const ProductIcons = {
  [ProductOptions.Settings]: "fa-link",
  [ProductOptions.Gateway]: "fa-copy",
}